import { useEffect, useState } from "react";
import { api, fmtCurrency } from "../../lib/api";
import MobileHeader from "../../components/MobileHeader";
import { Plus, ChevronRight, Package } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";

export default function BusinessProducts() {
    const [products, setProducts] = useState([]);
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({ name: "", price: "", stock: "" });
    const [busy, setBusy] = useState(false);

    const refresh = () => api.get("/business/products").then((r) => setProducts(r.data));
    useEffect(() => { refresh(); }, []);

    const submit = async () => {
        const price = parseFloat(form.price);
        const stock = parseInt(form.stock || "0", 10);
        if (!form.name || !price) return toast.error("Name and price required");
        setBusy(true);
        try {
            await api.post("/business/products", { name: form.name, price, stock });
            toast.success("Product added");
            setOpen(false);
            setForm({ name: "", price: "", stock: "" });
            refresh();
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div data-testid="business-products-page">
            <MobileHeader title="Products & Services" backTo="/business" variant="blue" />
            <div className="px-5 -mt-6 pb-4 space-y-3">
                <div className="bg-white rounded-2xl border border-slate-200/60 product-shadow overflow-hidden">
                    {products.length === 0 && <div className="p-8 text-center text-sm text-slate-500">No products yet</div>}
                    {products.map((p, i) => (
                        <div key={p.id} className={`flex items-center gap-3 px-4 py-3.5 ${i !== products.length - 1 ? "border-b border-slate-100" : ""}`} data-testid={`product-row-${p.id}`}>
                            <div className="size-10 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center">
                                <Package size={18} />
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="font-semibold text-sm">{p.name}</div>
                                <div className="text-xs text-slate-500">{fmtCurrency(p.price)} · Stock {p.stock}</div>
                            </div>
                            <ChevronRight size={16} className="text-slate-400" />
                        </div>
                    ))}
                </div>

                <Button onClick={() => setOpen(true)} className="w-full h-12 rounded-xl bg-[#0066FF] hover:bg-[#0052cc] font-semibold" data-testid="add-product-btn">
                    <Plus size={18} /> Add Product
                </Button>
            </div>

            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="rounded-2xl">
                    <DialogHeader><DialogTitle className="font-display">New Product</DialogTitle></DialogHeader>
                    <div className="space-y-3">
                        <div><Label>Name</Label><Input value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} className="mt-1.5 h-11 rounded-xl" data-testid="prod-name" /></div>
                        <div><Label>Price (NGN)</Label><Input type="number" value={form.price} onChange={(e) => setForm((f) => ({ ...f, price: e.target.value }))} className="mt-1.5 h-11 rounded-xl" data-testid="prod-price" /></div>
                        <div><Label>Stock</Label><Input type="number" value={form.stock} onChange={(e) => setForm((f) => ({ ...f, stock: e.target.value }))} className="mt-1.5 h-11 rounded-xl" data-testid="prod-stock" /></div>
                        <Button onClick={submit} disabled={busy} className="w-full h-11 rounded-xl bg-[#0A1930]" data-testid="prod-submit">{busy ? "Saving…" : "Add"}</Button>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}
